import {
  ChangeExportModeAction,
  CloseShareAviIDMsgAction,
  ResetExportPointsAction,
  SetAVIIdAction,
  SetAviListAction,
  SetEndPointAction,
  SetStartPointAction
}                                 from "./types";
import { BookmarkExportFormType } from "../bookmarks/types";

export const setStartPoint = (startPoint: number): SetStartPointAction => ({type: 'setStartPoint', startPoint});

export const setEndPoint = (endPoint: number, reverse?: boolean): SetEndPointAction => ({
  type: 'setEndPoint',
  endPoint,
  reverse
});

export const resetExportPoints = (): ResetExportPointsAction => ({type: 'resetExportPoints'});

export const changeExportsMode = (mode: string): ChangeExportModeAction => ({type: 'changeExportsMode', mode});

export const doExportFiles = (startTime: number, duration: number, pane: number, data: BookmarkExportFormType, locationPathname: string, bkmsId?: Array<number | string>) =>
  ({type: 'doExportFile', startTime, duration, pane, data, locationPathname, bkmsId});

export const getAviList = () => ({type: 'getAviList'});

export const setAviList = (avilist: any): SetAviListAction => ({type: 'setAvilist', avilist});

export const setAviID = (aviId: string): SetAVIIdAction => ({type: 'setAVIId', aviId});

export const closeShareAviIDMsg = (): CloseShareAviIDMsgAction => ({type: 'closeShareAviId'});

